// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3116f6ab] .el-dialog__body{overflow-y:auto!important}", ""]);
// Exports
module.exports = exports;
